/**
 * Created by bootdo.
 */
import axios from 'axios'
import store from "../vuex/store"
import {bus} from '../bus.js'

import webConfig from '@/config/config.js'

axios.defaults.withCredentials = true;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头
// 使用由库提供的配置的默认值来创建实例
// 此时超时配置的默认值是 `0`
let service = axios.create()

// 覆写库的超时默认值
// 现在，在超时前，所有请求都会等待 10 秒
service.defaults.timeout = 10000
//添加一个请求拦截器
service.interceptors.request.use(
  config => {
    let closeToken;
    if (config.method == 'post' && config.data) {
      let data = config.data;
      closeToken = data.closeToken;
      delete data.closeToken;
      config.data = data;
    } else if (config.params){
      closeToken = config.params.closeToken;
      delete  config.params.closeToken;
    }

    if (!closeToken && window.localStorage.getItem('access-token')) {
        config.headers.Authorization = window.localStorage.getItem('access-token');
    }

    config.headers.platformCode  = webConfig.platformCode;
    store.state.loading = true
    return config;
  },
  error => {
    return Promise.reject(error)
  }
);
// 添加一个响应拦截器
service.interceptors.response.use(function (response) {
  store.state.loading = false
  if (response.data && response.data.code) {
    if (parseInt(response.data.code) === 401) {
      //未登录
      console.log('-------------------------------------');
      bus.$emit('goto', '/login')
    }
  }

  return response;
}, function (error) {
	console.log(error);
	if(parseInt(error.response.status) === 401 && error.response.data.error=='invalid_token'){
		bus.$emit('goto', '/login')
	}else{
		store.state.loading = false
		// Do something with response error
		return Promise.reject(error);
	}

});
/**
 *
 * @type {string}
 */
//基地址
let base = process.env.API_ROOT


//通用方法
export const POST = (url, params, closeToken) => {
  if (closeToken) {
    params.closeToken = closeToken;
  }
  return service.post(`${base}${url}`, params).then(res => res.data)
}

export const GETBLOB = (url, params) => {
  return service.get(`${base}${url}`, {
    params: params,
    responseType:"blob"
  }).then(res => res.data)
}

export const GET = (url, params) => {
  return service.get(`${base}${url}`, {
    params: params,
  }).then(res => res.data)
}

export const actiGET = (url, params) => {
  console.error(`${url}`);
  return service.get(`${url}`, {
    params: params,
  }).then(res => res.data)
}

export const GET_BYTE = (url, params) => {
  return service.get(`${base}${url}`,{responseType: 'arraybuffer',params: params}).then(res => res.data)
}

export const PUT = (url, params) => {
  return service.put(`${base}${url}`, params).then(res => res.data)
}

export const DELETE = (url, params) => {
  return service.delete(`${base}${url}`, {
    params: params
  }).then(res => res.data)
}

export const PATCH = (url, params) => {
  return service.patch(`${base}${url}`, params).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/api/index.js